import { render, staticRenderFns } from "./SubMenuContainer.vue?vue&type=template&id=037695d1&scoped=true"
import script from "./SubMenuContainer.vue?vue&type=script&lang=js"
export * from "./SubMenuContainer.vue?vue&type=script&lang=js"
import style0 from "./SubMenuContainer.vue?vue&type=style&index=0&id=037695d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037695d1",
  null
  
)

export default component.exports